<div class="row container mb-4" id="cards-footer">

  <img width="100%" src="assets/img-analitico/divider_horizontal.svg" alt="" srcset="">
</div>

<div class=" row  card-container text-wrap" id="cards-footer-container">

  <!-- Card cadastro positivo -->
  <div class=" col-sm-12 col-md-12 col-lg-3 " id="cards-footer-cadastro-positivo">

    <div (click)="irPara('https://www.serasa.com.br/dados-cadastrais/', 'card-atualizacao-dados', 'Atualização de Dados', 3)" class="card" role="button">
      <div class="row justify-content-between rowTopCard">

        <div class="ml-4">
          <img height="36px" width="36px" src="assets/img-analitico/pencil.svg" alt="" srcset="">
        </div>
        <div class="mr-4">
          <img height="24px" width="24px" src="assets/img-analitico/open_in_new_black_24dp.svg" alt="" srcset="">
        </div>
      </div>

      <div class="row">
        <p class="mx-4 font-weight-bold" id="cards-footer-dados-cadastrais-titulo">
          <small class="text-bold"> <strong> Atualização de Dados </strong></small>
        </p>
      </div>

      <div class="row">
        <p class="mx-4 font-weight-bold " id="cards-footer-dados-cadastrais-descricao">
          <small class="text-bold">Você pode solicitar a alteração de suas informações cadastrais na Serasa de forma gratuita. Para atualizar seus dados cadastrais, clique aqui. </small>
        </p>
      </div>

    </div>

</div>

  <!-- Card cadastro positivo -->
  <div class="col-sm-12 col-md-12 col-lg-3 " id="cards-footer-cadastro-positivo">

      <div (click)="irPara('https://www.serasa.com.br/cadastro-positivo/', 'card-cadastro-positivo', 'Cadastro Positivo', 4)" class="card" role="button">
        <div class="row justify-content-between rowTopCard">
          <div class=" ml-4 ">
            <img height="36px" width="36px" src="assets/img-analitico/customer.svg" alt="" srcset="">
          </div>
          <div class="mr-4">
            <img height="24px" width="24px" src="assets/img-analitico/open_in_new_black_24dp.svg" alt="" srcset="">
          </div>
        </div>
        <div class="row">
          <p class="mx-4 font-weight-bold"  id="cards-footer-cadastro-positivo-titulo">
            <small class="text-bold"> <strong> Cadastro Positivo </strong></small>
          </p>
        </div>
        <div class="row">
          <p class="mx-4 font-weight-bold"  id="cards-footer-cadastro-positivo-descricao">
            <small class="text-bold">
              Para maiores informações e serviços do Cadastro Positivo, conheça a nossa página. Clique aqui.
            </small>
          </p>
        </div>

      </div>

  </div>

  <!-- Card serasa score -->
   <div class=" col-sm-12 col-md-12 col-lg-3 " id="cards-footer-score">
      <div (click)="irPara('https://www.serasa.com.br/score/', 'card-score', 'Serasa score', 5)" class="card" role="button">

        <div class="row justify-content-between rowTopCard">
          <div class="ml-4 ">
            <img height="36px" width="36px" src="assets/img-analitico/vehicle-checks.svg" alt="" srcset="">
          </div>
          <div class="mr-4">
            <img height="24px" width="24px" src="assets/img-analitico/open_in_new_black_24dp.svg" alt="" srcset="">
          </div>
        </div>
        <div class="row">
          <p class="mx-4 font-weight-bold" id="cards-footer-score-titulo">
            <small class="text-bold"> <strong> Serasa score </strong></small>
          </p>
        </div>
        <div class="row">
          <p class="mx-4 font-weight-bold" id="cards-footer-score-descricao">
            <small class="text-bold"> Para maiores informações sobre as variáveis que compõem sua pontuação de crédito, conheça a nossa página. Clique aqui. </small>
          </p>
        </div>

      </div>
  </div>

  <!-- Card seus dados -->
   <div class=" col-sm-12 col-md-12 col-lg-3 " id="cards-footer-seus-dados">
      <div (click)="openDialog()" class="card" role="button">

        <div class="row justify-content-between rowTopCard">
          <div class="ml-4 ">
            <img height="36px" width="36px" src="assets/img-analitico/folder-ico.svg" alt="" srcset="">
          </div>
          <div class="mr-4">
            <img height="24px" width="24px" src="assets/img-analitico/open_in_new_black_24dp.svg" alt="" srcset="">
          </div>
        </div>
        <div class="row">
          <p class="mx-4 font-weight-bold" id="cards-footer-seus-dados-titulo">
            <small class="text-bold"> <strong> Outras informações de dados </strong></small>
          </p>
        </div>
        <div class="row ">
          <p class="mx-4 font-weight-bold" id="cards-footer-seus-dados-descricao">
            <small class="text-bold"> É possível que existam outros dados para o seu CPF nas bases de dados da Serasa. Essas informações podem ser solicitadas e serão fornecidas em até 15 dias, a contar do recebimento da solicitação. Clique aqui. </small>
          </p>
        </div>

      </div>
  </div>


</div>
